import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';

export const mapAssets = ({ assets }) => {
  const mappedAssets = _map(assets, (asset) => {
    const splitObjectName = asset.s3ObjectName.split('_');
    const val = asset.primaryLink.split('?')[0];

    return {
      choiceId: splitObjectName[1],
      perspective: splitObjectName[2] || 0,
      mediaUrl: `${val}?fmt=png`
    };
  });

  return _keyBy(mappedAssets, 'choiceId');
};
